import React, { FC } from 'react';
import Container from 'react-bootstrap/Container';
import styles from './Account.module.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { Balance } from '../../components/Balance';
import { useTranslation } from 'react-i18next';
import {
  getCustomerId,
  getFirstName,
  getLastName,
  getSmartCardNumber,
} from '../../utils/localstorage/LocalStorageHelper';
import classNames from 'classnames';

const Account: FC = () => {
  const { t } = useTranslation();

  const lastName = getLastName();
  const customerNr = getCustomerId();
  const smartcardNr = getSmartCardNumber();
  const firstName = getFirstName();
  const withContrast = true;
  return (
    <Container>
      <div className={styles.pageHeader}>
        <Balance />
      </div>
      <h2>{t('accountPage.title')}</h2>
      <Row>
        <Col>
          <Accordion defaultActiveKey="0">
            <Card className={classNames(styles.card, {
              [styles.contrast]: withContrast,
            })}>
              <Card.Header className={classNames(styles.cardHeader, {
                [styles.contrast]: withContrast,
              })}>{t('accountPage.personalInfo')}</Card.Header>
              <Card.Body className={styles.cardBody}>
                <Form className={styles.form}>
                  <Form.Group as={Row}>
                    <Col md="6">
                      <Row className={styles.dataRow}>
                        <Form.Label column sm="6">
                          {t('accountPage.customerNumber')}
                        </Form.Label>
                        <Col sm="6">
                          <div className={`${styles.personalData} ${withContrast ? styles.contrast : ''}`}>{customerNr}</div>
                        </Col>
                        <Form.Label column sm="6">
                          {t('accountPage.firstName')}
                        </Form.Label>
                        <Col sm="6">
                          <div className={`${styles.personalData} ${withContrast ? styles.contrast : ''}`}>{firstName}</div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="6">
                      <Row className={styles.dataRow}>
                        <Form.Label column sm="6">
                          {t('accountPage.smartcardNumber')}
                        </Form.Label>
                        <Col sm="6">
                          <div className={`${styles.personalData} ${withContrast ? styles.contrast : ''}`}>{smartcardNr}</div>
                        </Col>
                        <Form.Label column sm="6">
                          {t('accountPage.lastName')}
                        </Form.Label>
                        <Col sm="6">
                          <div className={`${styles.personalData} ${withContrast ? styles.contrast : ''}`}>{lastName}</div>
                        </Col>
                      </Row>
                    </Col>
                  </Form.Group>
                </Form>
              </Card.Body>
            </Card>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default Account;
